import api, { handleApiResponse } from './api';
import {
  ApiResponse,
  CreateSupplierInvoiceRequest,
  SupplierInvoiceResponse,
  PaySupplierInvoiceRequest,
  TransactionResponseDTO,
} from '../types';

export const supplierInvoiceService = {
  // ==================== CREAR FACTURA ====================

  async createInvoice(
    request: CreateSupplierInvoiceRequest,
  ): Promise<SupplierInvoiceResponse> {
    const response = await api.post<ApiResponse<SupplierInvoiceResponse>>(
      '/supplier-invoices',
      request,
    );
    return handleApiResponse(response);
  },

  // ==================== ELIMINAR FACTURA ====================

  async deleteInvoice(id: number): Promise<void> {
    await api.delete<ApiResponse<void>>(`/supplier-invoices/${id}`);
  },

  // ==================== LISTAR TODAS LAS FACTURAS ====================

  async getAllInvoices(): Promise<SupplierInvoiceResponse[]> {
    const response =
      await api.get<ApiResponse<SupplierInvoiceResponse[]>>(
        '/supplier-invoices',
      );
    return handleApiResponse(response);
  },

  // ==================== OBTENER FACTURA POR ID ====================

  async getInvoiceById(id: number): Promise<SupplierInvoiceResponse> {
    const response = await api.get<ApiResponse<SupplierInvoiceResponse>>(
      `/supplier-invoices/${id}`,
    );
    return handleApiResponse(response);
  },

  // ==================== FACTURAS POR PROVEEDOR ====================

  async getInvoicesBySupplier(
    supplierId: number,
  ): Promise<SupplierInvoiceResponse[]> {
    const response = await api.get<ApiResponse<SupplierInvoiceResponse[]>>(
      `/supplier-invoices/by-supplier/${supplierId}`,
    );
    return handleApiResponse(response);
  },

  // ==================== FACTURAS POR ORDEN DE COMPRA ====================

  async getInvoicesByPurchaseOrder(
    purchaseOrderId: number,
  ): Promise<SupplierInvoiceResponse[]> {
    const response = await api.get<ApiResponse<SupplierInvoiceResponse[]>>(
      `/supplier-invoices/by-purchase-order/${purchaseOrderId}`,
    );
    return handleApiResponse(response);
  },

  // ==================== FACTURAS POR ESTADO ====================

  async getInvoicesByStatus(
    status: 'PENDIENTE' | 'PARCIALMENTE_PAGADA' | 'PAGADA',
  ): Promise<SupplierInvoiceResponse[]> {
    const response = await api.get<ApiResponse<SupplierInvoiceResponse[]>>(
      `/supplier-invoices/by-status/${status}`,
    );
    return handleApiResponse(response);
  },

  // ==================== REGISTRAR PAGO ====================

  async payInvoice(
    invoiceId: number,
    request: PaySupplierInvoiceRequest,
  ): Promise<SupplierInvoiceResponse> {
    const response = await api.post<ApiResponse<SupplierInvoiceResponse>>(
      `/supplier-invoices/${invoiceId}/pay`,
      request,
    );
    return handleApiResponse(response);
  },

  // ==================== TRANSACCIONES DE FACTURA ====================

  async getInvoiceTransactions(
    invoiceId: number,
  ): Promise<TransactionResponseDTO[]> {
    const response = await api.get<ApiResponse<TransactionResponseDTO[]>>(
      `/supplier-invoices/${invoiceId}/transactions`,
    );
    return handleApiResponse(response);
  },
};
